module.exports = __webpack_public_path__ + "img/blue_080.ebc05a42.png";